import Widget from "./base.js";
import { NewsletterSignupForm } from "./newsletter-signup-form.js";

// Presentational wrapper placed in the archive sidebar for signed-out visitors.
// Renders the per-newsletter list description and composes NewsletterSignupForm
// as a child. The form is the reusable bit; this block is the sidebar container.
//
// No GET, no state: the description is keyed off the category slug directly
// (slugMatch normalizes -/_), so no email-list fetch is needed here. The form
// owns its own GET to resolve list.id. PHP gates emission on $category.

// Normalize slugs for comparison: the legacy Brevo lists use underscores
// (the_backchannel) while editorial-newsletter rows use hyphens
// (the-backchannel). Match either convention so the widget works pre- and
// post-beehiiv-switchover.
const slugMatch = (a, b) => (a ?? "").replace(/[-_]/g, "-") === (b ?? "").replace(/[-_]/g, "-");

//uncomment to enable on more than one newsletter
const NEWSLETTER_CATEGORIES = [
	"the-brief",
	// "the-weekender",
	// "the-franchise",
	// "the-backchannel",
];

export class NewsletterSignupBlock extends Widget {

	listDescription(slug) {
		let title = null;
		let	description = null;

		if (slugMatch(slug, "the_weekender")) {
			title = "Subscribe to The Weekender Newsletter";
			description = "Unpack the funny, surreal, and strange in U.S. politics and culture with Allegra Kirkland, Derick Dirmaier and the TPM team.";
		}

		if (slugMatch(slug, "the_franchise")) {
			title = "Subscribe to The Franchise Newsletter";
			description = "What you need to know about the assault on voting rights and democracy in America, brought to you weekly by TPM reporter Khaya Himmelman.";
		}

		if (slugMatch(slug, "the_brief")) {
			title = "Subscribe to The Brief Newsletter";
			description = "In The Brief, Executive Editor John Light starts your day with some quick thoughts on key stories TPM will be following.";
		}

		if (slugMatch(slug, "the_backchannel")) {
			if (this.props.membership && this.props.membership === "1") {
				title = "Subscribe to The Backchannel Newsletter";
				description = "Josh Marshall's direct line for insight, analysis, and conversation. TPM members receive one must-read daily.";
			} else {
				title = "Subscribe to The Backchannel Newsletter";
				description = "Josh Marshall's direct line for insight, analysis, and conversation. Non-members can subscribe to the free edition and receive one must-read from Josh weekly.";
			}
		}

		if (slugMatch(slug, "where_things_stand")) {
			title = "Keep Up With Where Things Stand";
			description = "TPM's running guide to elections and democracy in America. Get the latest updates in your inbox.";
		}

		/* if title or description prop is present, use that instead */
		if (this.props.title) title = this.props.title;
		if (this.props.description) description = this.props.description;

		if (title && description) {
			return (
				<div>
					<div className="NewsletterSignupBlock__Title">{title}</div>
					<p>{description}</p>
				</div>
			);
		}

		return "";
	}

	newsletterSignupFormClasses() {
		if (this.props.signedin) return this.props.cssclasses + " --signedin";
		return this.props.cssclasses
	}

	renderContent() {
		if (!(this.props.categories || NEWSLETTER_CATEGORIES).includes(this.props.category)) return null;

		return (
			<div style={this.props.signedin ? { opacity: "0", pointerEvents: 'none' }: {}}>
				<div className="NewsletterSignupBlock__Description">
					{this.listDescription(this.props.category)}
				</div>
				<NewsletterSignupForm category={this.props.category} cssclasses={this.newsletterSignupFormClasses()} onConfirmation={this.props.onConfirmation} />
			</div>
		);
	}
}